import { render } from "./component-adress-ur.vue?vue&type=template&id=eefc93a0"
import script from "./component-adress-ur.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-ur.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-ur.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eefc93a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eefc93a0', __exports__)) {
    api.reload('eefc93a0', __exports__)
  }
  
  module.hot.accept("./component-adress-ur.vue?vue&type=template&id=eefc93a0", () => {
    api.rerender('eefc93a0', render)
  })

}


export default __exports__